import { useRef } from "react";
import { Search, X } from "lucide-react";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-fog" />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search sounds..."
        className="h-10 w-full rounded-[18px] border border-mist bg-slate pl-10 pr-8 text-sm text-parchment outline-none transition-colors placeholder:text-fog focus:border-spark focus:ring-2 focus:ring-spark/20"
      />
      {value && (
        <button
          onClick={() => {
            onChange("");
            inputRef.current?.focus();
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-fog hover:text-parchment"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
